import { useAddBtsCommentMutation } from "#graphql/supergraphHooks";
import type { TaskStepDetail } from "../../types";

export type TaskGroupOverride = { taskId: string; taskLabel: string };

export function usePostBtsComment(issueKey: string | undefined, task: TaskStepDetail) {
  const [addBtsComment] = useAddBtsCommentMutation();

  return (text: string, isInternal: boolean, taskGroupOverride?: TaskGroupOverride) => {
    if (!issueKey || !text.trim()) return;
    addBtsComment({
      variables: {
        issueKey,
        isInternal,
        body: {
          version: 1,
          type: "doc",
          content: [{ type: "paragraph", content: [{ type: "text", text }] }],
        },
        taskGroup: taskGroupOverride ?? {
          taskId: String(task.id),
          taskLabel: task.name,
        },
      },
    }).catch(() => undefined);
  };
}
